import { Box, Button, Spinner } from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import CustomForm from "common/utils/customForm";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import { globalStyles } from "common/theme/styles";
import { getApi } from "common/services/api";

const LeadInformation = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const initialFieldValues = Object.fromEntries(
    (props?.leadData?.fields || []).map((field) => [field?.name, ""])
  );

  const initialValues = {
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,// This forces Formik to reinitialize when props change
    // validationSchema: validationSchema,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.leadData?.fields)),
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;


  const AddData = async () => {
    try {
      setIsLoading(true);
      // let response = await postApi('api/lead/add', values)
      let response = await postApi("api/form/add", {
        ...values,
        moduleId: props?.leadData?._id,
      });
      if (response.status === 200) {
         toast.success(crmConstant.leadAddedSuccessfully);
        navigate("/crm/leads");
      }
    } catch (e) {
      toast.error(crmConstant.someThingWentWrong);
    } finally {
      setIsLoading(false);
      formik.resetForm();
    }
  };

  const handleBackPage = () => {
    navigate("/crm/leads");
  };
  
  return (
    <>
      <Box className="commonPanelBody">
        <CustomForm
          moduleData={props.leadData}
          values={values}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          className="theme-btn1"
          sx={{ textTransform: "capitalize" }}
          size="sm"
          disabled={isLoading ? true : false}
          variant="brand"
          type="submit"
        onClick={handleSubmit}
          
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateLead = () => {
  const [leadData, setLeadData] = useState([]);

  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate("/crm/leads");
  };

  const tabsData = [{ label: crmConstant.leadInformation, Icon: JobOpeningIcon }];

  const panelsData = [<LeadInformation leadData={leadData[0]} />];

  useEffect(() => {
    (async () => {
      const result = await getApi(`api/custom-field/?moduleName=Leads`);
      setLeadData(result?.data);
    })();
  }, []);

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createLead}
    />
  );
};

export default CreateLead;
